import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Home";
import Leads from "./Leads";
import ViewLeadDetails from "./ViewLeadDetails";
import Login from "./Login";
import PendingFollowUps from "./PendingFollowUps";
import NewLeads from "./NewLeads";
import AllFollowUps from "./AllFollowUps";
import MyLeads from "./MyLeads";
import CallerFollowUps from "./CallerFollowUps";
import CallerNewFollowUps from "./CallerNewFollowUps";
import NewR2V from "./NewR2V";
import ResetPassword from "./ResetPassword";
import WorkingDone from "./WorkingDone";
import LeadsAddedByMe from "./LeadsAddedByMe";
import CallerReport from "./CallerReport";
import AdminReport from "./AdminReport";
import AttendanceList from "./AttendanceList";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} exact />
        <Route path="/leads" element={<Leads />} exact />
        <Route path="/leads-added-by-me" element={<LeadsAddedByMe />} exact />
        <Route path="/my-leads" element={<MyLeads />} exact />
        <Route path="/new-followups" element={<CallerNewFollowUps />} exact />
        <Route path="/my-followups" element={<CallerFollowUps />} exact />
        <Route path="/working-done" element={<WorkingDone />} exact />
        <Route path="/my-report" element={<CallerReport />} exact />
        <Route path="/admin-report" element={<AdminReport />} exact />
        <Route path="/attendance-list" element={<AttendanceList />} exact />
        <Route path="/new-r2v" element={<NewR2V />} exact />
        {/* <Route path="/pending-follow-ups" element={<PendingFollowUps />} exact /> */}
        <Route path="/all-follow-ups" element={<AllFollowUps />} exact />
        <Route path="/new-leads" element={<NewLeads />} exact />
        <Route path="/view-lead-details/:leadId" element={<ViewLeadDetails />} exact />
        <Route path="/view-lead-details/:leadId/:visit" element={<ViewLeadDetails />} exact />
        <Route path="/login" element={<Login />} exact />
        <Route path="/reset-password" element={<ResetPassword />} exact />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
